'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.saveDataInSessionStorage = saveDataInSessionStorage;
exports.getDataFromSessionStorage = getDataFromSessionStorage;
var SessionStorageKeys = exports.SessionStorageKeys = {
  LinkAccountProviderKey: 'lnAcOpK',
  OldSessionId: 'OLD_SESSION_ID',
  SelectedProviderKey: 'sProdK'
};

function saveDataInSessionStorage(key, value) {
  window.sessionStorage.setItem(key, value);
}

function getDataFromSessionStorage(key) {
  return window.sessionStorage.getItem(key);
}


//////////////////
// WEBPACK FOOTER
// ./src/helpers/SessionStorage.js
// module id = 97
// module chunks = 0